// hooks/useInputFieldsConfig.js
import { useSelector } from 'react-redux';

export const useInputFieldsConfig = () => {
  const { GetGreeterCustData, GreeterSectionData, GetSalesPersonData } = useSelector(state => state.greeterData);

  return [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      // dataSourceKey: GetGreeterCustData,
      filterKey: 'name',
      relatedFields: {
        CustomerCode: 'CustomerCode', 
      },
    },
    {
      name: 'phnumber',
      label: 'Phone Number',
      type: 'dropdown',
      dataSourceKey: GetGreeterCustData,
      filterKey: 'phoneNumber',
    },
    {
      name: 'section',
      label: 'Section',
      type: 'dropdown',
      dataSourceKey: GreeterSectionData,
      filterKey: 'section',
    },
    {
      name: 'slp',
      label: 'Salesperson',
      type: 'dropdown',
      dataSourceKey: GetSalesPersonData,
      filterKey: 'slpName',
      relatedFields: {
        slpCode: 'slpCode', 
      },
    },
  ];
};
